import styled from "styled-components";

const DeliveryContainer = styled.div`
  color: var(--grey700);
  font-size: 14px;
  padding-top: ${({ padding = 7 }) => padding}px;
`;

export default DeliveryContainer;
